export const GamblePage = () => {
  return (
    <div className="gamble-page">
      Gamble page not unlocked yet.
    </div>
  )
};